import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { recentSearchesMap } from '../state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      recentInProjectSearches: (_, { variables }) => {
        const input = (
          variables as { input?: { userId?: string; projectId?: string } }
        )?.input;
        return recentSearchesMap.get(
          `${input?.userId}-${input?.projectId}`,
          []
        );
      },
    },
  },
};
